"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var ProductOptionsCustom = /** @class */ (function (_super) {
    __extends(ProductOptionsCustom, _super);
    function ProductOptionsCustom(props) {
        return _super.call(this, props) || this;
    }
    ProductOptionsCustom.prototype.render = function () {
        var _a = this.props, title = _a.title, fieldKey = _a.fieldKey, values = _a.values, setCustomOptions = _a.setCustomOptions, selected = _a.selected, showError = _a.showError;
        var valueList = values;
        if (valueList && valueList.length) {
            return (React.createElement("div", { className: "w-full mb-2-4 md:mb-3-6" },
                React.createElement("div", { className: "relative" },
                    React.createElement("div", { className: "absolute pin flex items-center justify-between pointer-events-none px-1-2 text-charcoal" },
                        React.createElement("p", { className: "text-sm font-medium" }, title),
                        React.createElement(Snippets.Svg, { name: "chevron-down", width: 16, className: "block" })),
                    React.createElement("select", { defaultValue: "0", className: "block appearance-none px-3-2 py-1-1 cursor-pointer border " + (showError ? "border-red" : "border-grey-mid") + " bg-transparent rounded-none w-full max-w-full focus:outline-none text-sm font-medium text-midnight text-last-right", onChange: function (e) { return setCustomOptions(fieldKey, e.target.value); } },
                        React.createElement("option", { disabled: true, value: "0" }, "Please Select an Option"),
                        valueList.map(function (value) { return (React.createElement("option", { value: value }, value)); }))),
                showError && React.createElement("span", { className: "font-sans text-red mt-0-4 text-sm font-medium w-full block" }, "Please select an option")));
        }
        return null;
    };
    return ProductOptionsCustom;
}(React.PureComponent));
exports.ProductOptionsCustom = ProductOptionsCustom;
